"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleBase = void 0;
class MarketRuleBase {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        /* eslint-disable no-empty */
    }
}
exports.MarketRuleBase = MarketRuleBase;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtYmFzZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2hpc3RvcmljYWwtcHJpY2luZy90aW1lLXNlcmllcy9zZXJ2aWNlcy9ydWxlLWVuZ2luZS1zZXJ2aWNlL2NsYXNzZXMvbWFya2V0LXJ1bGUtYmFzZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxNQUFzQixjQUFjO0lBQ2hDOzs7T0FHRztJQUNILFlBQW1CLEdBQTZCO1FBQzVDLDZCQUE2QjtJQUNqQyxDQUFDO0NBQ0o7QUFSRCx3Q0FRQyJ9